"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _ActionButtonsProvider = _interopRequireDefault(require("./ActionButtonsProvider"));

var QuestionErrorBlock = function QuestionErrorBlock(_ref) {
  var getInsertQuestionAndAnswerEnabled = _ref.getInsertQuestionAndAnswerEnabled,
      getEditorState = _ref.getEditorState,
      onEditorStateChange = _ref.onEditorStateChange,
      entityKey = _ref.entityKey;
  return _react.default.createElement(_ActionButtonsProvider.default, {
    disabled: !getInsertQuestionAndAnswerEnabled || !getInsertQuestionAndAnswerEnabled(),
    hideEditButton: true,
    onDeleteClicked: function onDeleteClicked() {
      return onEditorStateChange((0, _draftHelpers.deleteEntity)(entityKey, getEditorState()));
    }
  }, _react.default.createElement("div", {
    className: "question-and-answer-content",
    "data-selenium-test": "q-and-a-block"
  }, _react.default.createElement(_UITile.default, {
    className: "p-all-5 q-and-a-error"
  }, _react.default.createElement(_UIErrorMessage.default, {
    type: "404",
    title: _I18n.default.text('composer-plugins.questionAndAnswer.failedToLoad.title')
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.failedToLoad.body"
  })))));
};

QuestionErrorBlock.propTypes = {
  getInsertQuestionAndAnswerEnabled: _propTypes.default.func,
  getEditorState: _propTypes.default.func.isRequired,
  onEditorStateChange: _propTypes.default.func.isRequired,
  entityKey: _propTypes.default.string.isRequired
};
var _default = QuestionErrorBlock;
exports.default = _default;
module.exports = exports.default;